<div>
  <button mat-button mat-dialog-close="" style="float: right">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content style="clear: both">
  <h3 style="font-weight: bold">Email Sent Logs For: Ref# {{ReportInfo.ReferenceNumber}}</h3>
  <hr>

  <ng-template #EmailSentTPL let-report>
    {{report.SentTimestamp | date:'MM-dd-yyyy hh:mm:ss'}}
  </ng-template>

  <ejs-grid
    style="margin-top: 10px;"
    [dataSource]='EmailLog'
    [allowPaging]="true"
    [allowSorting]="true"
    [allowFiltering]="true"
    [filterSettings]="{type: 'CheckBox'}"
    [allowTextWrap]="true"
    [textWrapSettings]="{ wrapMode: 'Both' }"
  >
    <e-columns>
      <e-column field='FirstName' headerText='First Name'></e-column>
      <e-column field='LastName' headerText='Last Name'></e-column>
      <e-column field='ToEmail' headerText='EMAIL'></e-column>
      <e-column [template]="EmailSentTPL" field='SentTimestamp' headerText='Sent Timestamp' textAlign='Left'></e-column>
    </e-columns>
  </ejs-grid>
</div>
